module.exports = __webpack_public_path__ + "img/hotapp.b6f29399.png";